import { cameraApiRequest } from './cameraApiRequest';

/** The project's non-deleted cameras, by name: `{ cameras }`. */
export const getCameras = ({ projectId, activeEmployerInfo }) =>
  cameraApiRequest({
    method: 'GET',
    apiPath: `projects/${projectId}/cameras`,
    activeEmployerInfo,
  });
